/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NotificationBellIcon16Regular = forwardRef('NotificationBellIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 1.25a5 5 0 0 0-5 5v3.014L1.386 11.57A.75.75 0 0 0 2 12.75h3.5v.208a2.5 2.5 0 0 0 5 0v-.208H14a.75.75 0 0 0 .614-1.18L13 9.264V6.25a5 5 0 0 0-5-5Zm-3.5 5a3.5 3.5 0 1 1 7 0V9.5a.75.75 0 0 0 .136.43l.924 1.32H3.44l.924-1.32A.75.75 0 0 0 4.5 9.5V6.25Zm4.5 6.5H7v.208a1 1 0 1 0 2 0v-.208Z" })));
});
